export class PixiHelpers {

    private static maxTextureSize;
    /**
     * Converts the given point from stage coordinates to diagram coordinates.
     * @param point - The point in stage coordinates.
     * @returns The maximum supported quality
     */
    public static getWebglSupportedQuality( quality: number, width: number, height: number ): number {
        try {
            if ( !PixiHelpers.maxTextureSize ) {
                const canvas = document.createElement( 'canvas' );
                const gl = ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' )) as WebGLRenderingContext;
                PixiHelpers.maxTextureSize = gl.getParameter( gl.MAX_TEXTURE_SIZE ) * 0.8;
            }
            const maxTextureSize = PixiHelpers.maxTextureSize;
            const expectedWidth = width * quality;
            const expectedHeight = height * quality;
            const greaterDimension = Math.max( expectedWidth, expectedHeight );
            if( greaterDimension > maxTextureSize) {
                quality = maxTextureSize / ( greaterDimension / quality );
            }
            return quality;
        } catch ( e ) {
            // WebGL not supported
            return quality;
        }
    }

}